import { useForm } from "react-hook-form";
import { Yup, constants } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'

const {
    locale: {
        key: {
            CommonValidationMessageKeys,
        },
    },
} = constants

function ValidationSchema(translate) {
    let requiredMessage = translate(
        Namespace.COMMON_VALIDATION_MSG,
        CommonValidationMessageKeys.REQUIRED
    )

    return Yup.object({
        countryCode: Yup.string().required(requiredMessage),
        description: Yup.string().required(requiredMessage).max(512,"Max 512 characters are allowed "),
    })


}

export default ValidationSchema
